import React from 'react'
import Swal from 'sweetalert2';
import { Link } from "react-router-dom";
import Api from "../../services/Api";
import authAxios from "../../services/Token";
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faAt, faEdit, faHashtag, faTimes } from '@fortawesome/free-solid-svg-icons';

class Editar extends React.Component {
    constructor(props) {
        super(props);
    }
    state = {
        load: '',
        datosCargados: false,
        operador: [],
        errores: []
    }
    cambioValor = (e) => {
        const state = this.state.operador;
        state[e.target.name] = e.target.value;
        this.setState({ operador: state });
    };
    verificarError(elemento) {
        return this.state.errores.indexOf(elemento) !== -1;
    }
    enviarDatos = (e) => {
        e.preventDefault();
        const nit_operador = document.getElementById('nit_operador').value;
        const nombre = document.getElementById('nombre').value;
        var errores = [];
        if (!nombre) { errores.push("error_nombre"); }
        if (!nit_operador) { errores.push("error_nit_operador"); }
        this.setState({ errores: errores });
        if (errores.length > 0) {
            return false;
        }
        let form = document.getElementById('form');
        let formData = new FormData(form);
        console.log(formData);
        Swal.showLoading();
        authAxios.post("operadores/editar", formData)
            .then((datosRespuesta) => {
                console.log(datosRespuesta)
                Swal.close();
                Swal.fire(
                    'Operadores de Red!',
                    datosRespuesta.data.msj,
                    'success'
                )
                this.props.history.push("/MasterOperadores");
            })
            .catch(console.log)
    }

    componentDidMount() {
        Swal.showLoading();
        authAxios.get("operadores/ver/" + this.props.match.params.id)
            .then((datosRespuesta) => {
                console.log(datosRespuesta);
                this.setState({ datosCargados: true, operador: datosRespuesta.data, load: '' });
                Swal.close();
            })
            .catch(console.log);
    }

    render() {
        const { load, operador } = this.state;
        return (
            <div className="content-wrapper">
                <div className="content">
                    <div className="container-fluid">
                        <br />
                        <div className="card">
                            <div className="card-header text-center">
                                {load ? (<b>{load}</b>) : (<b>EDITAR OPERADOR DE RED</b>)}
                            </div>
                            <div className="card-body">
                                <form onSubmit={this.enviarDatos} id="form">
                                    <div className="row">
                                        <div className="col-xl-12">
                                            <div className='row g-3'>
                                                <div className="col-md-2">
                                                    <input type="hidden" name="id" value={this.props.match.params.id} />
                                                    <label htmlFor="nit_operador">NIT Operador de Red</label>
                                                    <div className="input-group input-group-sm">
                                                        <span className="input-group-text" id="inputGroupPrepend"><FontAwesomeIcon icon={faHashtag} /></span>
                                                        <input style={{ textTransform: 'uppercase' }} type="text" name="nit_operador" id="nit_operador" defaultValue={operador.NIT_OPERADOR}
                                                            className={((this.verificarError("error_nit_operador")) ? "is-invalid" : "") + " form-control form-control-sm"} placeholder="NIT OPERADOR DE RED" aria-describedby="helpId"
                                                            onChange={this.cambioValor}
                                                        />
                                                    </div>
                                                    <small id="helpId" className="invalid-feedback">Digite el NIT Operador de Red</small>
                                                </div>
                                                <div className="col-md-10">
                                                    <label htmlFor="nombre">Nombre</label>
                                                    <input style={{ textTransform: 'uppercase' }} type="text" name="nombre" id="nombre" defaultValue={operador.NOMBRE}
                                                        className={((this.verificarError("error_nombre")) ? "is-invalid" : "") + " form-control form-control-sm"} placeholder="NOMBRE" aria-describedby="helpId"
                                                        onChange={this.cambioValor}
                                                    />
                                                    <small id="helpId" className="invalid-feedback">Digite el Nombre</small>
                                                </div>
                                            </div>
                                            <div style={{ marginTop: 0 }} className='row g-3'>
                                                <div className="col-md-4">
                                                    <label htmlFor="rep_legal">Repr. Legal</label>
                                                    <input style={{ textTransform: 'uppercase' }} type="text" name="rep_legal" id="rep_legal" defaultValue={operador.REPR_LEGAL}
                                                        className="form-control form-control-sm" placeholder="REPR. LEGAL" aria-describedby="helpId"
                                                        onChange={this.cambioValor}
                                                    />
                                                </div>
                                                <div className="col-md-4">
                                                    <label htmlFor="direccion_oper">Dirección</label>
                                                    <input style={{ textTransform: 'uppercase' }} type="text" name="direccion_oper" id="direccion_oper" defaultValue={operador.DIRECCION_OPERADOR}
                                                        className="form-control form-control-sm" placeholder="DIRECCIÓN" aria-describedby="helpId"
                                                        onChange={this.cambioValor}
                                                    />
                                                </div>
                                                <div className="col-md-4">
                                                    <label htmlFor="correo_electronico_oper">Correo Electrónico</label>
                                                    <div className="input-group input-group-sm">
                                                        <span className="input-group-text" id="inputGroupPrepend"><FontAwesomeIcon icon={faAt} /></span>
                                                        <input style={{ textTransform: 'uppercase' }} type="text" name="correo_electronico_oper" id="correo_electronico_oper" defaultValue={operador.CORREO_ELECTRONICO}
                                                            className="form-control form-control-sm" placeholder="CORREO ELECTRÓNICO" aria-describedby="helpId"
                                                            onChange={this.cambioValor}
                                                        />
                                                    </div>
                                                </div>
                                            </div>
                                            <div style={{ marginTop: 0 }} className='row g-3'>
                                                <div className="col-md-3">
                                                    <label htmlFor="resp_oper">Responsable</label>
                                                    <input style={{ textTransform: 'uppercase' }} type="text" name="resp_oper" id="resp_oper" defaultValue={operador.RESPONSABLE_ACARGO}
                                                        className="form-control form-control-sm" placeholder="RESPONSABLE" aria-describedby="helpId"
                                                        onChange={this.cambioValor}
                                                    />
                                                </div>
                                                <div className="col-md-3">
                                                    <label htmlFor="cargo_resp_oper">Cargo Responsable</label>
                                                    <input style={{ textTransform: 'uppercase' }} type="text" name="cargo_resp_oper" id="cargo_resp_oper" defaultValue={operador.CARGO_RESPONSABLE}
                                                        className="form-control form-control-sm" placeholder="CARGO RESPONSABLE" aria-describedby="helpId"
                                                        onChange={this.cambioValor}
                                                    />
                                                </div>
                                                <div className="col-md-3">
                                                    <label htmlFor="telefono_resp_oper">Telefono Responsable</label>
                                                    <div className="input-group input-group-sm">
                                                        <span className="input-group-text" id="inputGroupPrepend"><FontAwesomeIcon icon={faHashtag} /></span>
                                                        <input style={{ textTransform: 'uppercase' }} type="text" name="telefono_resp_oper" id="telefono_resp_oper" defaultValue={operador.TELEFONO_RESPONSABLE}
                                                            className="form-control form-control-sm" placeholder="TELEFONO RESPONSABLE" aria-describedby="helpId"
                                                            onChange={this.cambioValor}
                                                        />
                                                    </div>
                                                </div>
                                                <div className="col-md-3">
                                                    <label htmlFor="correo_electronico_resp_oper">Correo Electrónico Responsable</label>
                                                    <div className="input-group input-group-sm">
                                                        <span className="input-group-text" id="inputGroupPrepend"><FontAwesomeIcon icon={faAt} /></span>
                                                        <input style={{ textTransform: 'uppercase' }} type="text" name="correo_electronico_resp_oper" id="correo_electronico_resp_oper" defaultValue={operador.CORREO_RESPONSABLE}
                                                            className="form-control form-control-sm" placeholder="CORREO ELECTRÓNICO RESP." aria-describedby="helpId"
                                                            onChange={this.cambioValor}
                                                        />
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                    <hr />
                                    <div className='row'>
                                        <div className='col-xl-12 text-center'>
                                            <div className="btn-group" role="group" aria-label="">
                                                <button type="submit" className="btn btn-primary btn-sm"><FontAwesomeIcon icon={faEdit} />&nbsp;&nbsp;Editar Oper. de Red</button>&nbsp;&nbsp;
                                                <Link className="btn btn-danger btn-sm" to={"/MasterOperadores"}><FontAwesomeIcon icon={faTimes} />&nbsp;&nbsp;Cancelar</Link>
                                            </div>
                                        </div>
                                    </div>
                                </form>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        );
    }
}

export default Editar;